// extracted by mini-css-extract-plugin
module.exports = {"logo":"SimplifiedRoutes_logo__2m1Hw","simplified":"SimplifiedRoutes_simplified__1eMqN","approve_estimate":"SimplifiedRoutes_approve_estimate__2ytj-"};